import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7c58967a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "home"
};
var _hoisted_2 = {
  id: "about",
  class: "home-top"
};
var _hoisted_3 = {
  class: "content-box width-auto"
};
var _hoisted_4 = {
  class: "content-text"
};
var _hoisted_5 = ["src"];

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", null, "南京汇智互娱网络科技有限公司成立于2017年6月，公司自主研发汇智数智云SaaS—新经济数字化服务平台。将云计算、大数据、人工智能、SaaS模式运用到互联网数字服务领域，形成标准化的业务体系，服务面向文旅、酒店、零售、餐饮、快消、制造等多行业，为全国中小企业与个人消费者提供多维度、全方位数字化和智能化的一站式服务。"), /*#__PURE__*/_createElementVNode("span", null, "旗下拥有生活服务SaaS平台、云达人SaaS平台、电商供应链SaaS平台、游戏电竞SaaS平台、产业元宇宙SaaS平台等多个产品，此外，还提供直播代运营、达人代运营、电商代运营、达人孵化、新媒体广告投放、短视频制作、电竞赛事等多项服务。为企业提供从前端业务拓展到后端经营决策，全链路一体化数字转型的解决方案。截止目前，已经为超过10000家知名企业和中小商家提供深度服务。"), /*#__PURE__*/_createElementVNode("span", null, "汇智互娱专注于新经济数字化运营服务，聚焦客户品牌产品全生命周期，挖掘用户增长契机。")], -1);
});

var _hoisted_7 = {
  class: "intro-box"
};
var _hoisted_8 = {
  class: "width-auto"
};
var _hoisted_9 = ["src"];

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, "持续突破"), /*#__PURE__*/_createElementVNode("span", null, "坚持“长期主义”和“价值共生”")], -1);
});

var _hoisted_11 = ["src"];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, "开放协作"), /*#__PURE__*/_createElementVNode("span", null, "秉持信任与尊重，迎接挑战与机遇")], -1);
});

var _hoisted_13 = ["src"];

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, "匠心服务"), /*#__PURE__*/_createElementVNode("span", null, "用立体服务促进价值分享")], -1);
});

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
    class: "line"
  })], -1);
});

var _hoisted_16 = {
  class: "special"
};
var _hoisted_17 = {
  class: "little"
};
var _hoisted_18 = ["src"];

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "使命：让数字科技美好生活", -1);
});

var _hoisted_20 = {
  class: "little"
};
var _hoisted_21 = ["src"];

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "愿景：成为国内领先的新经济数字化运营管理平台", -1);
});

var _hoisted_23 = {
  id: "workModel",
  class: "mode-box"
};

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "mode-title"
  }, [/*#__PURE__*/_createElementVNode("p", null, "数字化解决方案"), /*#__PURE__*/_createElementVNode("span", null, "人+货+场为客户提供数字化转型解决方案，赋能增收")], -1);
});

var _hoisted_25 = {
  class: "tabs-box width-auto"
};
var _hoisted_26 = ["onClick"];
var _hoisted_27 = {
  class: "tabs-content"
};
var _hoisted_28 = {
  class: "width-auto"
};
var _hoisted_29 = {
  key: 0,
  class: "content-box"
};
var _hoisted_30 = {
  class: "content-left"
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "生活服务SaaS平台"), /*#__PURE__*/_createElementVNode("p", null, " 生活服务SaaS平台是汇智数智云旗下针对生活服务类商家出品的商家运营管理工具，化身你的直播间、达人媒介、广告投流、商品选品管家，可以实时追踪千川投放流量、随时查看销售数据，帮助你复盘数据诊断线上营销全过程；更有AI排班、主播贡献值、任务派发、项目进度查看等功能，助力高效管理线上运营团队。 ")], -1);
});

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "联系我们", -1);
});

var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-more_icon"
  }, null, -1);
});

var _hoisted_34 = [_hoisted_32, _hoisted_33];
var _hoisted_35 = {
  class: "content-right"
};
var _hoisted_36 = {
  class: "prod"
};
var _hoisted_37 = ["src"];
var _hoisted_38 = {
  class: "scheme-box"
};

var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "tips"
  }, " 行业解决方案涵盖：景区、酒店、餐饮、美容、美发、休闲等 ", -1);
});

var _hoisted_40 = {
  class: "title"
};

var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "行业解决方案", -1);
});

var _hoisted_42 = ["onClick"];
var _hoisted_43 = {
  class: "img-box"
};
var _hoisted_44 = ["src"];
var _hoisted_45 = {
  key: 1,
  class: "content-box"
};
var _hoisted_46 = {
  class: "content-left"
};

var _hoisted_47 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "云达人SaaS平台"), /*#__PURE__*/_createElementVNode("p", null, " 云达人SaaS平台是汇智数智云旗下针对头部达人、素人达人、探店达人、品宣达人出品的达人接单工具，化身达人的经纪管家，可以实时追踪自己流量、随时查看销售数据，帮助你复盘数据诊断线上推广全过程；更有AIGC智能一键剪辑功能，助力高效短视频带货线上运营团队。 ")], -1);
});

var _hoisted_48 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "联系我们", -1);
});

var _hoisted_49 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-more_icon"
  }, null, -1);
});

var _hoisted_50 = [_hoisted_48, _hoisted_49];
var _hoisted_51 = {
  class: "content-right"
};
var _hoisted_52 = {
  class: "prod"
};
var _hoisted_53 = ["src"];
var _hoisted_54 = {
  class: "scheme-box"
};
var _hoisted_55 = {
  class: "title"
};

var _hoisted_56 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "行业解决方案", -1);
});

var _hoisted_57 = ["onClick"];
var _hoisted_58 = {
  class: "img-box-two"
};
var _hoisted_59 = ["src"];
var _hoisted_60 = {
  key: 2,
  class: "content-box"
};
var _hoisted_61 = {
  class: "content-left"
};

var _hoisted_62 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "电商供应链SaaS平台"), /*#__PURE__*/_createElementVNode("p", null, " 将计划、采购、生产、分销、服务等活动紧密衔接在一起，实现企业内部产供销、企业财税一体化；通过社会化协同，将上游与下游企业涉及的供应商、生产商、分销商，以及金融、物流服务商等企业间的商流、物流、信息流、资金流形成一体化运作；通过开放的生态融合服务，为企业提供更多的供应链服务。从而不断提升企业供应链管理水平，保证产业链供应链稳定，实现敏捷供应、高效协同。 ")], -1);
});

var _hoisted_63 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "联系我们", -1);
});

var _hoisted_64 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-more_icon"
  }, null, -1);
});

var _hoisted_65 = [_hoisted_63, _hoisted_64];
var _hoisted_66 = {
  class: "content-right"
};
var _hoisted_67 = {
  class: "prod"
};
var _hoisted_68 = ["src"];
var _hoisted_69 = {
  class: "scheme-box"
};
var _hoisted_70 = {
  class: "title"
};

var _hoisted_71 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "行业解决方案", -1);
});

var _hoisted_72 = ["onClick"];
var _hoisted_73 = {
  class: "img-box-two"
};
var _hoisted_74 = ["src"];
var _hoisted_75 = {
  key: 3,
  class: "content-box"
};
var _hoisted_76 = {
  class: "content-left"
};

var _hoisted_77 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "游戏电竞SaaS平台"), /*#__PURE__*/_createElementVNode("p", null, " 围绕“游戏线上下推广、赛事IP打造、快捷办赛、赛事运营、商业资源撮合、电竞人才培养“等电竞场景布局，目前比夫电竞APP—标准化电竞工具，涵盖多种功能组件 ，包括“赛程组件、智能办赛组件、报名组件、赛事管理组件、赛训组件、制播组件、营销推广“等。汇智数智云游戏电竞SaaS工具集提供“管理端、配置端、用户端”等多种角色系统及权限区隔，真正支持多方协同办赛的现实场景。 ")], -1);
});

var _hoisted_78 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "联系我们", -1);
});

var _hoisted_79 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-more_icon"
  }, null, -1);
});

var _hoisted_80 = [_hoisted_78, _hoisted_79];
var _hoisted_81 = {
  class: "content-right"
};
var _hoisted_82 = {
  class: "prod"
};
var _hoisted_83 = ["src"];
var _hoisted_84 = {
  class: "scheme-box"
};
var _hoisted_85 = {
  class: "title"
};

var _hoisted_86 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "行业解决方案", -1);
});

var _hoisted_87 = ["onClick"];
var _hoisted_88 = {
  class: "img-box"
};
var _hoisted_89 = ["src"];
var _hoisted_90 = {
  key: 4,
  class: "content-box"
};
var _hoisted_91 = {
  class: "content-left"
};

var _hoisted_92 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "产业元宇宙SaaS平台"), /*#__PURE__*/_createElementVNode("p", null, " 云达人SaaS平台是汇智数智云旗下针对头部达人、素人达人、探店达人、品宣达人出品的达人接单工具，化身达人的经纪管家，可以实时追踪自己流量、随时查看销售数据，帮助你复盘数据诊断线上推广全过程；更有AIGC智能一键剪辑功能功能，助力高效短视频带货线上运营团队。 ")], -1);
});

var _hoisted_93 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "联系我们", -1);
});

var _hoisted_94 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-more_icon"
  }, null, -1);
});

var _hoisted_95 = [_hoisted_93, _hoisted_94];
var _hoisted_96 = {
  class: "content-right"
};
var _hoisted_97 = {
  class: "prod"
};
var _hoisted_98 = ["src"];
var _hoisted_99 = {
  class: "scheme-box"
};
var _hoisted_100 = {
  class: "title"
};

var _hoisted_101 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "行业解决方案", -1);
});

var _hoisted_102 = ["onClick"];
var _hoisted_103 = {
  class: "img-box-two"
};
var _hoisted_104 = ["src"];
var _hoisted_105 = {
  class: "develop-box"
};

var _hoisted_106 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, [/*#__PURE__*/_createElementVNode("p", null, "发展历程"), /*#__PURE__*/_createElementVNode("span", null, "行业孕育巨大发展空间，汇智互娱正迎来大发展时代")], -1);
});

var _hoisted_107 = {
  class: "develop-body width-auto"
};
var _hoisted_108 = {
  class: "develop-point-content"
};
var _hoisted_109 = {
  class: "develop-point-content-title"
};
var _hoisted_110 = {
  class: "point-scroll-box"
};

var _hoisted_111 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "荣誉", -1);
});

var _hoisted_112 = {
  class: "develop-point"
};
var _hoisted_113 = {
  class: "arrows-box"
};
var _hoisted_114 = ["src"];
var _hoisted_115 = {
  class: "develop-point-circle-box"
};
var _hoisted_116 = ["onMouseenter", "onMouseleave"];
var _hoisted_117 = {
  class: "develop-point-circle"
};
var _hoisted_118 = ["src"];
var _hoisted_119 = {
  class: "honor-box"
};

var _hoisted_120 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title width-auto"
  }, [/*#__PURE__*/_createElementVNode("p", null, "荣誉成就"), /*#__PURE__*/_createElementVNode("span", null, "数字化营销服务，全面赋能品牌商家数字化转型升级")], -1);
});

var _hoisted_121 = {
  class: "img-box width-auto"
};
var _hoisted_122 = {
  class: "patent"
};
var _hoisted_123 = ["src"];

var _hoisted_124 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "部分专利", -1);
});

var _hoisted_125 = {
  class: "honor"
};
var _hoisted_126 = ["src"];

var _hoisted_127 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "部分荣誉", -1);
});

var _hoisted_128 = {
  class: "co-branding-box"
};

var _hoisted_129 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, [/*#__PURE__*/_createElementVNode("p", null, "合作品牌"), /*#__PURE__*/_createElementVNode("span", null, "数字化营销服务，全面赋能品牌商家数字化转型升级")], -1);
});

var _hoisted_130 = {
  class: "width-auto"
};
var _hoisted_131 = ["src"];
var _hoisted_132 = ["src"];
import { ref, reactive, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import { NModal, NTabs, NTabPane } from 'naive-ui';
import { Pagination } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'vue3-video-play/dist/style.css';
import { contentList, buffSportsList, buffCultureList, developList, developInfo, brandList, tpList, gameList, digitList, mcnList, mcnSonList, cloudList, cloudSonList, supplyList, supplySonList, electronicList, electronicSonList, metaverseList, metaverseSonList } from '@/data/home.ts';
import Head from '@/components/head.vue';
import Footer from '@/components/footer.vue';
import { useRouter } from 'vue-router';
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var modules = reactive([Pagination]);
    var showLinkModal = ref(false);
    var pageData = reactive({
      intro: '汇智互娱集团是国内领先的新经济数字化运营服务商，旗下包括江苏汇智互娱智能科技有限公司、南京比夫网络科技有限公司、南京比夫文化传播有限公司等子公司；集团围绕多元化产业服务链路，以新媒体数字营销服务、全球产业供应链、信息流广告运营、品牌营销策划等多个板块为业务核心，有效地将品牌市场营销诉求融入到新的消费场景，高效推动线下品牌商产业升级，利用5G、大数据分析等技术的发展与进步，为客户在数据智能产业发展中获得更大的利益。',
      introTwo: '',
      introMore: true,
      contentList: contentList,
      buffSportsList: buffSportsList,
      buffCultureList: buffCultureList,
      showCollModal: false,
      developList: developList,
      developInfo: developInfo,
      developActive: 0,
      isBgColor: false,
      swiper: null,
      isScroll: false,
      brandList: brandList,
      tabList: ['生活服务SaaS平台', '云达人SaaS平台', '电商供应链SaaS平台', '游戏电竞SaaS平台', '产业元宇宙SaaS平台'],
      active: 0,
      businessType: '',
      tpList: tpList,
      gameList: gameList,
      digitList: digitList,
      mcnList: mcnList,
      mcnSonList: mcnSonList,
      cloudList: cloudList,
      cloudSonList: cloudSonList,
      supplyList: supplyList,
      supplySonList: supplySonList,
      electronicList: electronicList,
      electronicSonList: electronicSonList,
      metaverseList: metaverseList,
      metaverseSonList: metaverseSonList,
      currentPlayer: {},
      linkData: [{
        title: '生活服务SaaS平台',
        src: 'pc/contactus/contactus1_pop_img@3x.png',
        btnText: '我要合作',
        type: 'mc'
      }, {
        title: '云达人SaaS平台',
        src: 'pc/contactus/contactus2_pop_img@3x.png',
        btnText: '我要合作',
        type: 'cloud'
      }, {
        title: '电商供应链SaaS平台',
        src: 'pc/contactus/contactus3_pop_img@3x.png',
        btnText: '我要合作',
        type: 'supply'
      }, {
        title: '游戏电竞SaaS平台',
        src: 'pc/contactus/contactus4_pop_img@3x.png',
        btnText: '我要合作',
        type: 'electronic'
      }, {
        title: '产业元宇宙SaaS平台',
        src: 'pc/contactus/contactus5_pop_img@3x.png',
        btnText: '我要合作',
        type: 'metaverse'
      }]
    });
    var list = reactive({
      data: []
    }); // console.log(list.data)

    var introRef = ref(null);
    var bannerRef = ref(null);
    var stepVideo = ref(null);

    var _getCurrentInstance = getCurrentInstance(),
        proxy = _getCurrentInstance.proxy;

    function onPlayerPlay(player, index) {
      //解决视频可以多个并行播放的问题，实现唯一视频播放，使用中间变量存放当前播放视频，播放其他视频时，暂停当前视频即可
      if (index === 1) {
        setTimeout(function () {
          proxy.$refs && proxy.$refs.stepVideo2[0].pause();
        }, 100);
      }

      if (index === 2) {
        setTimeout(function () {
          proxy.$refs && proxy.$refs.stepVideo1[0].pause();
        }, 100);
      }
    }

    onBeforeUnmount(function () {
      window.removeEventListener('scroll', handleScroll);
    });
    onMounted(function () {
      window.addEventListener('scroll', handleScroll);
    });

    function handleScroll() {
      var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
      var bannerHeight = bannerRef.value.offsetHeight;

      if (scrollY > 80) {
        pageData.isBgColor = true;
      } else {
        pageData.isBgColor = false;
      }
    }

    function linkModelShow() {
      showLinkModal.value = true;
    }

    function linkQrCode() {
      pageData.showCollModal = true;
    }

    function updateCollModal(v) {
      showLinkModal.value = v;
    }

    function updateQrCode(v) {
      pageData.showCollModal = v;
    } // function handleJump(index:number) {
    //   pageData.showCollModal = true
    // }
    // 产品功能联系我们按钮


    function handleLinkUs(item) {
      //   LS("生活服务SaaS"),
      //   CW("云达人SaaS"),
      //   ESP("电商供应链SaaS"),
      //   GE("游戏电竞SaaS"),
      //   PD("产业元宇宙SaaS"),
      // if (item === 'mc') {
      //   pageData.businessType = 'LS'
      // } else if (item === 'cloud') {
      //   pageData.businessType = 'CW'
      // } else if (item === 'supply') {
      //   pageData.businessType = 'ESP'
      // } else if (item === 'electronic') {
      //   pageData.businessType = 'GE'
      // } else if (item === 'metaverse') {
      //   pageData.businessType = 'PD'
      // }
      pageData.showCollModal = true;
    }

    function handleDevelop(item, index) {
      pageData.developInfo = item;
      pageData.developActive = index;
      setTimeout(function () {
        var parent = document.getElementsByClassName('develop-point-scroll')[0];
        var child = document.getElementsByClassName('point-scroll-box')[0];

        if (child.clientHeight > parent.clientHeight) {
          var arr = [];

          for (var i in pageData.developInfo.descs) {
            arr.push(pageData.developInfo.descs[i]);
          }

          for (var _i in pageData.developInfo.tips) {
            arr.push(pageData.developInfo.tips[_i]);
          }

          list.data = arr;
        }
      }, 500);
    }

    function handleDevelopLeave() {
      list.data = [];
    }

    var onSwiper = function onSwiper(swiper) {
      pageData.swiper = swiper;
    };

    var handelSwiperClick = function handelSwiperClick(el, swiper) {
      if (el.activeIndex !== el.clickedIndex) {
        pageData.swiper.slideTo(el.clickedIndex, 1000);
      }
    };

    function handleTabClick(index) {
      pageData.active = index;
    }

    var activeIndex = ref(0);

    function handleModelClick(index, i) {
      pageData.tpList[index].content.map(function (item) {
        item.active = false;
        return item;
      });
      pageData.tpList[index].content[i].active = true;
    }

    function handleWatchMore(item) {
      router.push('/case');
    }

    var videoPauseShow = ref(true);
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Head, {
        "is-bg-color": _unref(pageData).isBgColor,
        onLinkModelShow: linkQrCode
      }, null, 8, ["is-bg-color"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "bg-box",
        ref_key: "bannerRef",
        ref: bannerRef
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: _ctx.$filters.addOssDomainToPath('pc/home/title_img@2x.png'),
        alt: ""
      }, null, 8, _hoisted_5), _hoisted_6])])], 512), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", _hoisted_8, [_createElementVNode("li", null, [_createElementVNode("img", {
        src: _ctx.$filters.addOssDomainToPath('icon/tupo_icon@2x.png'),
        alt: ""
      }, null, 8, _hoisted_9), _hoisted_10]), _createElementVNode("li", null, [_createElementVNode("img", {
        src: _ctx.$filters.addOssDomainToPath('icon/xiezuo_icon@2x.png'),
        alt: ""
      }, null, 8, _hoisted_11), _hoisted_12]), _createElementVNode("li", null, [_createElementVNode("img", {
        src: _ctx.$filters.addOssDomainToPath('icon/fuwu_icon@2x.png'),
        alt: ""
      }, null, 8, _hoisted_13), _hoisted_14]), _hoisted_15, _createElementVNode("li", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
        src: _ctx.$filters.addOssDomainToPath('icon/shiming_icon.png'),
        alt: ""
      }, null, 8, _hoisted_18), _hoisted_19]), _createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
        src: _ctx.$filters.addOssDomainToPath('icon/yuanjiung_icon@2x.png'),
        alt: ""
      }, null, 8, _hoisted_21), _hoisted_22])])])])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("ul", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).tabList, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onClick: function onClick($event) {
            return handleTabClick(index);
          },
          class: _normalizeClass({
            active: _unref(pageData).active === index
          })
        }, _toDisplayString(item), 11, _hoisted_26);
      }), 128))]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_unref(pageData).active === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", {
        class: "btn",
        onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
          return handleLinkUs('mc');
        }, ["stop", "prevent"]))
      }, _hoisted_34)]), _createElementVNode("div", _hoisted_35, [_createVNode(_unref(NTabs), {
        type: "segment"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(NTabPane), {
            name: "chap1",
            tab: "产品功能"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_36, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mcnList), function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_37), _createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.desc1), 1)]);
              }), 128))])])];
            }),
            _: 1
          }), _createVNode(_unref(NTabPane), {
            name: "chap2",
            tab: "行业解决方案"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("p", {
                onClick: _withModifiers(handleWatchMore, ["stop", "prevent"])
              }, "查看更多>", 8, _hoisted_42)]), _createElementVNode("div", _hoisted_43, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).mcnSonList, function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_44), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item.desc1), 1), _createElementVNode("span", null, _toDisplayString(item.desc2), 1), _createElementVNode("span", null, _toDisplayString(item.desc3), 1), _createElementVNode("span", null, _toDisplayString(item.desc4), 1)])]);
              }), 128))])])])];
            }),
            _: 1
          })];
        }),
        _: 1
      })])])) : _createCommentVNode("", true), _unref(pageData).active === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
          return handleLinkUs('cloud');
        }, ["stop", "prevent"]))
      }, _hoisted_50)]), _createElementVNode("div", _hoisted_51, [_createVNode(_unref(NTabs), {
        type: "segment"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(NTabPane), {
            name: "chap1",
            tab: "产品功能"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_52, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cloudList), function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_53), _createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.desc1), 1)]);
              }), 128))])])];
            }),
            _: 1
          }), _createVNode(_unref(NTabPane), {
            name: "chap2",
            tab: "行业解决方案"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_hoisted_56, _createElementVNode("p", {
                onClick: _withModifiers(handleWatchMore, ["stop", "prevent"])
              }, "查看更多>", 8, _hoisted_57)]), _createElementVNode("div", _hoisted_58, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).cloudSonList, function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_59), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item.desc1), 1), _createElementVNode("span", null, _toDisplayString(item.desc2), 1), _createElementVNode("span", null, _toDisplayString(item.desc3), 1), _createElementVNode("span", null, _toDisplayString(item.desc4), 1)])]);
              }), 128))])])])];
            }),
            _: 1
          })];
        }),
        _: 1
      })])])) : _createCommentVNode("", true), _unref(pageData).active === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_hoisted_62, _createElementVNode("div", {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
          return handleLinkUs('supply');
        }, ["stop", "prevent"]))
      }, _hoisted_65)]), _createElementVNode("div", _hoisted_66, [_createVNode(_unref(NTabs), {
        type: "segment"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(NTabPane), {
            name: "chap1",
            tab: "产品功能"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_67, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(supplyList), function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_68), _createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.desc1), 1)]);
              }), 128))])])];
            }),
            _: 1
          }), _createVNode(_unref(NTabPane), {
            name: "chap2",
            tab: "行业解决方案"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_hoisted_71, _createElementVNode("p", {
                onClick: _withModifiers(handleWatchMore, ["stop", "prevent"])
              }, "查看更多>", 8, _hoisted_72)]), _createElementVNode("div", _hoisted_73, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).supplySonList, function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_74), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item.desc1), 1), _createElementVNode("span", null, _toDisplayString(item.desc2), 1), _createElementVNode("span", null, _toDisplayString(item.desc3), 1), _createElementVNode("span", null, _toDisplayString(item.desc4), 1)])]);
              }), 128))])])])];
            }),
            _: 1
          })];
        }),
        _: 1
      })])])) : _createCommentVNode("", true), _unref(pageData).active === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_hoisted_77, _createElementVNode("div", {
        class: "btn",
        onClick: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
          return handleLinkUs('electronic');
        }, ["stop", "prevent"]))
      }, _hoisted_80)]), _createElementVNode("div", _hoisted_81, [_createVNode(_unref(NTabs), {
        type: "segment"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(NTabPane), {
            name: "chap1",
            tab: "产品功能"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_82, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(electronicList), function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_83), _createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.desc1), 1), _createElementVNode("span", null, _toDisplayString(item.desc2), 1), _createElementVNode("span", null, _toDisplayString(item.desc3), 1)]);
              }), 128))])])];
            }),
            _: 1
          }), _createVNode(_unref(NTabPane), {
            name: "chap2",
            tab: "行业解决方案"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_hoisted_86, _createElementVNode("p", {
                onClick: _withModifiers(handleWatchMore, ["stop", "prevent"])
              }, "查看更多>", 8, _hoisted_87)]), _createElementVNode("div", _hoisted_88, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).electronicSonList, function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_89), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item.desc1), 1), _createElementVNode("span", null, _toDisplayString(item.desc2), 1), _createElementVNode("span", null, _toDisplayString(item.desc3), 1), _createElementVNode("span", null, _toDisplayString(item.desc4), 1)])]);
              }), 128))])])])];
            }),
            _: 1
          })];
        }),
        _: 1
      })])])) : _createCommentVNode("", true), _unref(pageData).active === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_hoisted_92, _createElementVNode("div", {
        class: "btn",
        onClick: _cache[4] || (_cache[4] = _withModifiers(function ($event) {
          return handleLinkUs('metaverse');
        }, ["stop", "prevent"]))
      }, _hoisted_95)]), _createElementVNode("div", _hoisted_96, [_createVNode(_unref(NTabs), {
        type: "segment"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(NTabPane), {
            name: "chap1",
            tab: "产品功能"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_97, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(metaverseList), function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_98), _createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.desc1), 1)]);
              }), 128))])])];
            }),
            _: 1
          }), _createVNode(_unref(NTabPane), {
            name: "chap2",
            tab: "行业解决方案"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_99, [_createElementVNode("div", _hoisted_100, [_hoisted_101, _createElementVNode("p", {
                onClick: _withModifiers(handleWatchMore, ["stop", "prevent"])
              }, "查看更多>", 8, _hoisted_102)]), _createElementVNode("div", _hoisted_103, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).metaverseSonList, function (item, index) {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("img", {
                  src: _ctx.$filters.addOssDomainToPath(item.img),
                  alt: ""
                }, null, 8, _hoisted_104), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item.desc1), 1), _createElementVNode("span", null, _toDisplayString(item.desc2), 1), _createElementVNode("span", null, _toDisplayString(item.desc3), 1), _createElementVNode("span", null, _toDisplayString(item.desc4), 1)])]);
              }), 128))])])])];
            }),
            _: 1
          })];
        }),
        _: 1
      })])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_105, [_hoisted_106, _createElementVNode("div", _hoisted_107, [_createElementVNode("div", {
        class: _normalizeClass(["develop-point-img-body", ["develop-point-img-body-".concat(_unref(pageData).developActive)]])
      }, [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, _toDisplayString(_unref(pageData).developInfo.time) + " " + _toDisplayString(_unref(pageData).developInfo.title), 1), _createVNode(_unref(Vue3SeamlessScroll), {
        list: _unref(list).data,
        class: "hidden-scroll develop-point-scroll",
        step: 0.5
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_110, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).developInfo.descs, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "develop-point-content-text"
            }, _toDisplayString(item), 1);
          }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).developInfo.tips, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              class: "develop-point-content-tips-box",
              key: index
            }, [_hoisted_111, _createElementVNode("span", null, _toDisplayString(item), 1)]);
          }), 128))])];
        }),
        _: 1
      }, 8, ["list", "step"])])], 2), _createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, function (item) {
        return _createElementVNode("div", {
          key: item
        }, [_createElementVNode("img", {
          class: "arrows",
          src: _ctx.$filters.addOssDomainToPath('icon/process1_icon@2x.png'),
          alt: ""
        }, null, 8, _hoisted_114)]);
      }), 64))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).developList, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["develop-point-body", {
            active: _unref(pageData).developActive === index
          }]),
          key: index
        }, [_createElementVNode("div", _hoisted_115, [_createElementVNode("div", {
          class: "develop-point-time",
          onMouseenter: _withModifiers(function ($event) {
            return handleDevelop(item, index);
          }, ["stop", "prevent"]),
          onMouseleave: _withModifiers(handleDevelopLeave, ["stop", "prevent"])
        }, _toDisplayString(item.time), 41, _hoisted_116), _createElementVNode("div", _hoisted_117, _toDisplayString(item.title), 1), _unref(pageData).developActive === index ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: _normalizeClass(["mark-".concat(index)]),
          src: _ctx.$filters.addOssDomainToPath('icon/process3_icon@2x.png'),
          alt: ""
        }, null, 10, _hoisted_118)) : _createCommentVNode("", true)])], 2);
      }), 128))])])]), _createElementVNode("div", _hoisted_119, [_hoisted_120, _createElementVNode("div", _hoisted_121, [_createElementVNode("div", _hoisted_122, [_createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, function (i) {
        return _createElementVNode("li", {
          key: i
        }, [_createElementVNode("img", {
          src: _ctx.$filters.addOssDomainToPath("pc/home2/patent".concat(i, "_img@2x.png")),
          alt: ""
        }, null, 8, _hoisted_123)]);
      }), 64))]), _hoisted_124]), _createElementVNode("div", _hoisted_125, [_createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, function (i) {
        return _createElementVNode("li", {
          key: i
        }, [_createElementVNode("img", {
          src: _ctx.$filters.addOssDomainToPath("pc/home2/honor".concat(i, "_img@2x.png")),
          alt: ""
        }, null, 8, _hoisted_126)]);
      }), 64))]), _hoisted_127])])]), _createElementVNode("div", _hoisted_128, [_hoisted_129, _createElementVNode("ul", _hoisted_130, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(48, function (i) {
        return _createElementVNode("li", {
          key: i
        }, [_createElementVNode("img", {
          src: _ctx.$filters.addOssDomainToPath("pc/brand/hezuo".concat(i, "_img.png")),
          alt: ""
        }, null, 8, _hoisted_131)]);
      }), 64))])]), _createVNode(Footer), _createVNode(_unref(NModal), {
        to: "body",
        "display-directive": 'if',
        show: _unref(pageData).showCollModal,
        "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
          return _unref(pageData).showCollModal = $event;
        }),
        "on-update:show": updateQrCode,
        preset: "dialog",
        "auto-focus": false,
        style: {
          "width": "29.5vw",
          "min-width": "450px",
          "padding": "55px 64px 20px 64px",
          "--n-content-margin": "0"
        },
        showIcon: false
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_createElementVNode("img", {
            src: _ctx.$filters.addOssDomainToPath('miniQrCode.jpg'),
            style: {
              "width": "100%"
            },
            alt: ""
          }, null, 8, _hoisted_132)])];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
});